<template>
<div class="container-fluid" >
   <modal-spinner v-if="modalSpinner.show==true" @close="setModalSpinner(false)" v-bind:props="modalSpinner"></modal-spinner>
  
    <div class="row"> 
    <div class="col-md-12">

    <button  @click="$emit('close')"  class="btn btn-secondary  ml-1 ">
    <i style="color:yellow" class="fas fa-reply mr-2" aria-hidden="true"></i>
    RITORNA A LISTA TRASFERIMENTI
    </button>

    <button v-if="false" type="button" class="btn btn-success ml-3 mr-4" @click="openBarcodeScan()" data-toggle="modal" data-target="#scan">
    ATTIVA INPUT SCANSIONE
    </button>

    <button  @click="set_sandBox()"  class="btn btn-outline-secondary  ml-4 mr-1">
    <i  class="far fa-copy mr-2" aria-hidden="true"></i>
    SOSPENDI OPERAZIONI
    </button>
    <button  @click="get_sandBox()"  class="btn btn-outline-secondary ">
    <i  class="fas fa-paste mr-2" aria-hidden="true"></i>
    RIPRENDI OPERAZIONI
    </button>

    <alert-box @close="msg.title=''" v-bind:msg="msg"  ></alert-box>

    <h4 style="color:crimson;font-size:24px" v-if="items.length>0" class="text-center mt-2 mb-2 "><strong>
      <i style="font-size:26px" class="fas fa-barcode mr-3" aria-hidden="true"></i>
     MATCHING PRODOTTI - PRONTO ALLA SCANSIONE
    <i style="font-size:26px" class="fas fa-barcode ml-3" aria-hidden="true"></i>
    </strong>
    </h4>  

<!-- Modal -->
<div class="modal" id="scan" data-backdrop="static" data-keyboard="false" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
  <div class="modal-dialog">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title" id="exampleModalLabel">SCANSIONE BARCODE</h5>
        <button type="button" class="close" @click="closeBarcodeScan()" data-dismiss="modal" aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body">
        <form v-on:submit.prevent="setBarcode()">
          <div class="form-group">
            <input  required type="number" class="form-control" id="inputScan"  v-model="barcode">
            <small id="inputHelp" class="form-text">Digita o scansiona un codice a barre prodotto.</small>
          </div>

          <!--<button type="submit" class="btn btn-primary">Submit</button>-->
        </form>
      </div>
      <alert-box class="ml-1 mr-1" @close="msg.title=''" v-bind:msg="msg"  ></alert-box>
      
    </div>
  </div>
</div>


<!--
<form v-on:submit.prevent="setBarcode()">
  
  <div class="form-group">
   
    <input required v-focus type="number" class="form-control"  v-model="barcode">
    <small id="inputHelp" class="form-text">Digita o scansiona un codice a barre prodotto.</small>
  </div>
  <button type="submit" class="btn btn-primary">Submit</button>
</form>
-->


<div class="table-wrapper-scroll-y my-custom-scrollbar mt-1">
  <table class="table table-hover table-striped mb-0">
    <thead >
      <tr class="table-primary">
        <th scope="col">#</th>
        <th scope="col">ID PRODOTTO</th>
        <th scope="col">BRAND</th>
        <th scope="col">CATEGORIA</th>
        
        <th scope="col">CODICE</th>
        <th scope="col">REPARTO</th>
        <th scope="col">STAGIONE</th>
     
        <th scope="col">COLORE</th>
        <th scope="col">MISURA</th>
        <th class="text-right" scope="col">QTA' TRASFERITA</th>
        <th class="text-right" scope="col">QTA' MATCH</th>
        <th scope="col">EAN 13</th>
       
      </tr>
    </thead>
    <tbody>
      
      <tr v-bind:style="[{backgroundColor : item.match_qty > item.qty ? 'violet':''}]"  v-for="(item, index) in items"  :key="index">
        <td>{{index+1}}</td>
        <td>{{item.productId}}</td>
        <td>{{item.brand}}</td>
        <td>{{item.category}}</td>        
        <td>{{item.sku}}</td>
        <td>{{item.department}}</td>
        <td>{{item.season}}-{{item.season_year}} </td>
        <td>{{item.color}} </td>
        <td>{{item.size}} </td>        
        
        <td class="text-right"><strong>{{item.qty}}</strong></td>
        <td v-bind:style="{color: item.match_qty != item.qty ? 'red':'black'}" class="text-right"><strong>{{item.match_qty}}</strong></td>
        <td>{{item.barcode}}</td>
       
      </tr> 
      
      
    </tbody>
    <tfoot>
        <tr> 
        <td></td>        
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>        
        <td></td>                
        <td></td>
        <td></td>
        <td class="text-right"> {{total1}}</td>
        <td class="text-right"> {{total2}}</td>
        <td></td>               
        </tr>   
    </tfoot>    
  </table>
    
</div>





</div>

<!-- row-->
</div>




</div>



</template>
<script>
const synth = window.speechSynthesis
let voices = []
voices = synth.getVoices()

import onScan from 'onscan.js'
//import scannerDetection    from '@/scanner';  
import api                 from "@/api";

import alertBox          from '@/components/common/AlertBox.vue'
import modalSpinner      from '@/components/common/ModalSpinner.vue'


import {mapGetters }    from 'vuex';
export default {
   props      : ['stockMovementId'],
  components  : {alertBox,modalSpinner},
  data() {
    return {
    
 
   // type                   : 'A',
 
    items                  : [],
    barcode                : '',
    msg                    : {
        title : '',
        body  : '',
        type  : 0
      },
    spinner                : false,     
    total1                 : 0,
    total2                 : 0,
    refresh                : 100,
    modalSpinner           : {spinner:false,show:false},
      
    
     
    }
  },
  computed :{
   
     ...mapGetters(['storeId']),
    
  },
  directives: {
    focus: {
      // directive definition
      inserted: function(el) {
        el.focus();
      }
    }
  },
   mounted : function()
  {

    this.initScan()
    this.getData()    
  },
  beforeDestroy () {
   onScan.detachFrom(document);
  
        //$(document).scannerDetection(false);
    },
  

  created: function() {
    


  },
  methods: {
    
  
    setModalSpinner(show)
    {
      

      this.modalSpinner.show = show
      
    },
    openBarcodeScan()
    {
      onScan.detachFrom(document);
      $('#scan').on('shown.bs.modal', function () {
      $('#inputScan').trigger('focus')
      })
    },
    closeBarcodeScan()
    {
      this.initScan()
    },
    initScan()
    {
      onScan.attachTo(document, {
      suffixKeyCodes: [13],        // enter-key expected at the end of a scan
      reactToPaste: true,          // Compatibility to built-in scanners in paste-mode (as opposed to keyboard-mode)
      onScan : (sCode, iQty) =>  { // Alternative to document.addEventListener('scan')
        this.msg.title = ''
        if(this.items.length==0)
        {
          /*
          this.msg.title = "ATTENZIONE "
          this.msg.body  = "Selezionare un campione di prodotti."
          this.msg.type  = 1
          */
        
          return
        }
        this.setMatch(sCode)
        //alert('Scanned: ' + iQty + 'x ' + sCode)
        console.log('Scanned: ' + iQty + 'x ' + sCode); 
    },
    
    
    onKeyDetect: function(iKeyCode){ // output all potentially relevant key events - great for debugging!
        console.log('Pressed: ' + iKeyCode);
    }
    
})
    },
    set_sandBox()
    {      
      if(this.items.length > 0)
      {
       
        localStorage.setItem('stockMovementMatching',JSON.stringify(this.items))
        this.items = []


      }
        
    },
    get_sandBox()
    {
        var items = JSON.parse(localStorage.getItem('stockMovementMatching'))
        if(items)
        {
         
            
          this.items = items
          
        }
        
    },
    check()
    {
      
      let arr = this.items.filter(item => item.qty != item.match_qty)

    },
    setTotal2 : function()
    {
       let total= 0
       this.items.forEach(item=>
          total += Number(item.match_qty)
       )
       this.total2 = total
    },
    setMatch(barcode)
    {
     
      
     
      let arr = this.items.filter(item => item.barcode == barcode)
     
      if(arr.length==0)
      {

        this.modalSpinner.show    = true
        this.modalSpinner.spinner = false
        this.modalSpinner.title = 'ATTENZIONE'
        this.modalSpinner.msg = 'Prodotto non presente sul trasferimento.'
        let msg = new SpeechSynthesisUtterance('Prodotto non presente sul trasferimento');  
                  msg.voice = voices[11];
                  msg.pitch = 1;
                  msg.rate = 1;
                  synth.speak(msg);

        /*
        this.msg.title = 'ATTENZIONE '
        this.msg.body = 'Articolo non presente sul trasferimento.'
        this.msg.type = 1
        */
        return
      }
     
     

      let index = arr[0].row_index
      this.items[index-1].match_qty++
      this.setTotal2()
     
     
    }, 
    setBarcode()
    {
      
      let arr = this.items.filter(item => item.barcode == this.barcode)
      this.barcode = ''
      if(arr.length==0)
      {
        this.msg.title = 'ATTENZIONE '
        this.msg.body = 'Articolo non presente sul trasferimento.'
        this.msg.type = 1
        
        return
      }

      
      let index = arr[0].row_index
      this.items[index-1].match_qty++
      this.setTotal2()

    },   
   
   
   
    async getData() {
    
  
      this.msg.title = ''

      this.modalSpinner.show    = true
      this.modalSpinner.spinner = true
      this.modalSpinner.title   = 'Caricamento prodotti in corso ...'
      
      this.total = 0
      //this.spinner = true
      this.items   = []
      
      var data     = {
      
      'stockMovementId' : this.stockMovementId 
    
      } 
      
      
      var sp = {'sp':'spProductsMatchingMovement'}
      var json    = Object.assign(data, sp)
      
         await api.post(json).then(res => {
          
          this.modalSpinner.show = false
          if(res.status==200)
            {
              
              this.items     = res.data.recordsets[0]
            
              this.total1    = 0
              this.items.forEach(item=>{
                this.total1 += item.qty
              })
              

             
              this.msg.title = ''
              //this.type = 'B'
            }
            else if (res.status==500)
            {
              
              this.modalSpinner.spinner = false            
              this.modalSpinner.msg = res.data
              /*
              this.msg.title = 'ATTENZIONE '
              this.msg.body  = res.data
              this.msg.type  = 1
              */
              
            }
          
          else
          {

            this.modalSpinner.spinner = false            
            this.modalSpinner.msg = res
            /*
            this.msg.title = 'ATTENZIONE '
            this.msg.body  = res
            this.msg.type  = 1
            */
            
          }
      }).catch(err=>{
        
        this.modalSpinner.spinner = false            
        this.modalSpinner.msg = err.message
            /*
            this.msg.title = 'ATTENZIONE '
            this.msg.body  = err.message
            this.msg.type  = 1      
            */

      })
      
      //this.spinner = false
    
    }
  }
};
</script>
<style scoped>

.my-custom-scrollbar {
position: relative;
height: 600px;
overflow: auto;
}
.pointer:hover
{
  background-color: blue;
  color: white;
  cursor: pointer;
}
.table-wrapper-scroll-y {
display: block;
}


.table thead tr:nth-child(1) th
 {

    font-family  : 'Roboto Condensed';
    font-size    : 16px;
    background   : #f19b06; 
    color        :  black;
    position     : sticky;
    top          : 0;
    z-index      : 10;

 }


 .table tfoot  tr:nth-child(1) td
 {

    font-family  : 'Roboto Condensed';
    font-weight  : bold;
    font-size    : 24px;
    background   : whitesmoke;
    color        : green;   
    position     : sticky;
    bottom       : 0;
    z-index      : 10;
    height       : 50px;

 }

h4 {
  font-family: 'Roboto Condensed';
  font-size: 20px;
}
tr {
  font-family: 'Roboto Condensed';
}
</style>